import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ExpandableItem } from 'src/app/models/menu-item';

@Component({
  selector: 'app-sidenav-cell',
  standalone: false,
  templateUrl: './sidenav-cell.component.html',
  styleUrls: ['./sidenav-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavCellComponent {
  /** Visual state class names for the root button. */
  public static readonly CELL_BEHAVE_SELECTED = 'selected';
  
  public static readonly CELL_BEHAVE_UNSELECTED = 'un-selected';

  @Output() public cellClickHandler = new EventEmitter<string>();

  @Output() public subcellClickHandler = new EventEmitter<string>();

  @Input() public id = '';
  
  @Input() public text = '';
  
  @Input() public icon = '';
  
  @Input() public isSelected = false;

  private _expand: ExpandableItem[] = [];

  public get expand(): ExpandableItem[] {
    return this._expand;
  }

  /** Only items not explicitly hidden. */
  public get visibleItems(): ExpandableItem[] {
    return this._expand.filter((it) => it?.visible !== false);
  }


  /** Items shown when expanded. Setter normalizes undefined → [] */
  @Input() public set expand(value: ExpandableItem[] | undefined) {
    this._expand = value ?? [];
  }

  /** Toggle main cell; when opening, ensure one child is selected. */
  public sidenavClicked(): void {
    this.cellClickHandler.emit(this.id);
    this.isSelected = !this.isSelected;

    if (this.isSelected && this._expand.length > 0 && !this._expand.some((x) => x.isSelected)) {
      const first = this.visibleItems[0];
    
      if (first) {
        const targetId = first.id;

        this._expand = this._expand.map((it) => {
          const nextSelected = it.id === targetId;
        
          if (it.isSelected === nextSelected) {
            return it;
          }
          return { ...it, isSelected: nextSelected };
        });
      }
    }
  }

  /** Select a submenu item immutably. */
  public subSidenavClicked(id: string): void {
    if (this._expand.length > 0) {
      this._expand = this._expand.map((it) => {
        const next = it.id === id;
        
        return it.isSelected === next ? it : { ...it, isSelected: next };
      });
    }
    this.subcellClickHandler.emit(id);
  }

  /** TrackBy to avoid re-rendering all buttons on small changes. */
  public trackById(_index: number, item: ExpandableItem): string {
    return item.id;
  }
}
